(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const ease = 'cubic-bezier(.22,1,.36,1)';
  const active = new Set();
  const seen = new WeakSet();
  const run = (element, frames, options = {}) => {
    if (!element || preference.matches || !element.animate) return Promise.resolve();
    const animation = element.animate(frames, {duration:600,easing:ease,...options});
    active.add(animation);
    return animation.finished.catch(() => {}).finally(() => active.delete(animation));
  };
  const cancel = root => {
    for (const animation of active) {
      const target = animation.effect?.target;
      if (target && (root === target || root.contains(target))) animation.cancel();
    }
    root.classList.remove('nz-closing');
  };
  const displacement = dialog => dialog.matches('.menu-panel') ? 'translateX(-100%)' : dialog.matches('.bag-dialog') ? 'translateX(100%)' : 'translateY(24px) scale(.97)';
  const reveal = element => run(element,[{opacity:0,transform:'translateY(22px)'},{opacity:1,transform:'none'}],{duration:760});
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      reveal(entry.target);
    }
  },{threshold:.12}) : null;
  function init(root) {
    root.querySelectorAll('.section-heading,.category-card,.product-card,.editorial-copy,.brand-story,.clarity>div,.closing h2').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (observer && !preference.matches && !window.Shopify?.designMode) observer.observe(element);
    });
  }
  window.NuzzlinoMotion = {
    cancel,
    filter(root) {
      root.querySelectorAll('[data-c03-pet]:not([hidden]) .product-card').forEach((el,index) => run(el,[{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'none'}],{duration:500,delay:Math.min(index,3)*45,fill:'backwards'}));
    },
    open(dialog) {
      cancel(dialog);
      run(dialog,[{opacity:.65,transform:displacement(dialog)},{opacity:1,transform:'none'}],{duration:480});
      dialog.querySelectorAll('.menu-panel nav>a,.cart-line,.empty-bag,.shipping-progress').forEach((el,index) => {
        run(el,[{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'none'}],{duration:480,delay:70+Math.min(index,5)*35,fill:'backwards'});
      });
    },
    exit(dialog) {
      const style = getComputedStyle(dialog);
      const from = {opacity:style.opacity,transform:style.transform};
      cancel(dialog);
      dialog.classList.add('nz-closing');
      return run(dialog,[from,{opacity:.65,transform:displacement(dialog)}],{duration:200,easing:'cubic-bezier(.4,0,1,1)'}).then(() => dialog.classList.remove('nz-closing'));
    },
    cart(previous) {
      document.querySelectorAll('[data-shipping-progress]').forEach(root => {
        const max = Number(root.dataset.threshold), total = Number(root.dataset.subtotal);
        const start = Math.min(1,Math.max(0,(previous?.subtotal ?? total)/max));
        const end = Math.min(1,Math.max(0,total/max));
        if (start !== end) run(root.querySelector('.shipping-progress-fill'),[{transform:`scaleX(${start})`},{transform:`scaleX(${end})`}],{duration:650});
        if (previous && previous.subtotal < max && total >= max) run(root.querySelector('p'),[{opacity:.3,transform:'translateY(5px)'},{opacity:1,transform:'none'}],{duration:500});
      });
      if (previous && previous.count !== document.querySelector('[data-cart-count]')?.textContent) {
        document.querySelectorAll('[data-cart-count]').forEach(el => run(el,[{transform:'scale(1)'},{transform:'scale(1.22)',offset:.35},{transform:'scale(1)'}],{duration:400}));
      }
    }
  };
  init(document);
  document.querySelectorAll('.hero-copy>.eyebrow,.hero h1,.hero-description,.hero-copy>.button,.hero-links').forEach((el,index) => {
    if (!window.Shopify?.designMode) run(el,[{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'none'}],{duration:800,delay:index*65,fill:'backwards'});
  });
  document.addEventListener('shopify:section:load',e => init(e.target));
  document.addEventListener('toggle',e => {
    if (e.target.matches('details[open]')) run(e.target.querySelector('.rte'),[{opacity:0,transform:'translateY(-5px)'},{opacity:1,transform:'none'}],{duration:300});
  },true);
  let frame;
  const scroll = () => {
    if (frame) return;
    frame=requestAnimationFrame(() => {frame=0;document.body.classList.toggle('nz-scrolled',scrollY>24)});
  };
  window.addEventListener('scroll',scroll,{passive:true});scroll();
  preference.addEventListener('change',() => {if(preference.matches){observer?.disconnect();for(const animation of active)animation.cancel();}});
})();
